/* ============================================================
   MONT GLACE — mini WebGL engine (pa librari)
   1) Hero: terren malor low-poly
   2) PDP: xhaketë 3D 360°
   ============================================================ */
(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mat4 ---------- */
  function ident() { return new Float32Array([1,0,0,0, 0,1,0,0, 0,0,1,0, 0,0,0,1]); }
  function mul(a, b) {
    var o = new Float32Array(16);
    for (var i = 0; i < 4; i++) for (var j = 0; j < 4; j++) {
      o[i * 4 + j] = a[j] * b[i * 4] + a[4 + j] * b[i * 4 + 1] + a[8 + j] * b[i * 4 + 2] + a[12 + j] * b[i * 4 + 3];
    }
    return o;
  }
  function persp(fovy, asp, n, f) {
    var t = 1 / Math.tan(fovy / 2), o = new Float32Array(16);
    o[0] = t / asp; o[5] = t; o[10] = (f + n) / (n - f); o[11] = -1; o[14] = 2 * f * n / (n - f);
    return o;
  }
  function lookAt(e, c, up) {
    var z = norm([e[0] - c[0], e[1] - c[1], e[2] - c[2]]);
    var x = norm(cross(up, z)), y = cross(z, x);
    return new Float32Array([
      x[0], y[0], z[0], 0, x[1], y[1], z[1], 0, x[2], y[2], z[2], 0,
      -dot(x, e), -dot(y, e), -dot(z, e), 1]);
  }
  function rotY(a) { var s = Math.sin(a), c = Math.cos(a); var m = ident(); m[0] = c; m[2] = -s; m[8] = s; m[10] = c; return m; }
  function rotX(a) { var s = Math.sin(a), c = Math.cos(a); var m = ident(); m[5] = c; m[6] = s; m[9] = -s; m[10] = c; return m; }
  function trans(x, y, z) { var m = ident(); m[12] = x; m[13] = y; m[14] = z; return m; }
  function cross(a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; }
  function dot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
  function norm(a) { var l = Math.hypot(a[0], a[1], a[2]) || 1; return [a[0] / l, a[1] / l, a[2] / l]; }

  /* ---------- shaders ---------- */
  var VS = [
    'attribute vec3 aPos;attribute vec3 aNor;attribute vec3 aCol;',
    'uniform mat4 uP,uV,uM;uniform vec3 uLight;uniform float uFogN,uFogF;',
    'varying vec3 vCol;varying float vFog;',
    'void main(){',
    ' vec4 wp=uM*vec4(aPos,1.0);',
    ' vec3 n=normalize(mat3(uM)*aNor);',
    ' float d=max(dot(n,normalize(uLight)),0.0);',
    ' float amb=0.44+0.20*max(n.y,0.0);',
    ' vec4 vp=uV*wp;',
    ' vFog=clamp((-vp.z-uFogN)/(uFogF-uFogN),0.0,1.0);',
    ' vCol=aCol*(amb+0.78*d);',
    ' gl_Position=uP*vp;}'
  ].join('\n');
  var FS = [
    'precision mediump float;varying vec3 vCol;varying float vFog;uniform vec3 uFogC;uniform float uFade;',
    'void main(){vec3 c=mix(vCol,uFogC,vFog*0.9);gl_FragColor=vec4(c,(1.0-vFog*uFade));}'
  ].join('\n');

  function prog(gl) {
    function sh(t, src) {
      var s = gl.createShader(t); gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { console.warn(gl.getShaderInfoLog(s)); return null; }
      return s;
    }
    var v = sh(gl.VERTEX_SHADER, VS), f = sh(gl.FRAGMENT_SHADER, FS);
    if (!v || !f) return null;
    var p = gl.createProgram(); gl.attachShader(p, v); gl.attachShader(p, f); gl.linkProgram(p);
    if (!gl.getProgramParameter(p, gl.LINK_STATUS)) return null;
    return p;
  }

  function ctx(canvas) {
    try {
      return canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false, depth: true })
        || canvas.getContext('experimental-webgl', { alpha: true, antialias: true });
    } catch (e) { return null; }
  }

  /* ---------- mesh helper (flat shaded, jo-indeksuar) ---------- */
  function Mesh() { this.p = []; this.n = []; this.c = []; }
  Mesh.prototype.tri = function (a, b, c, col) {
    var u = [b[0] - a[0], b[1] - a[1], b[2] - a[2]], v = [c[0] - a[0], c[1] - a[1], c[2] - a[2]];
    var nn = norm(cross(u, v));
    this.p.push(a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]);
    for (var i = 0; i < 3; i++) { this.n.push(nn[0], nn[1], nn[2]); this.c.push(col[0], col[1], col[2]); }
  };
  Mesh.prototype.quad = function (a, b, c, d, col) { this.tri(a, b, c, col); this.tri(a, c, d, col); };
  Mesh.prototype.upload = function (gl) {
    function buf(arr) { var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(arr), gl.STATIC_DRAW); return b; }
    return { p: buf(this.p), n: buf(this.n), c: buf(this.c), count: this.p.length / 3 };
  };
  function bindDraw(gl, p, m) {
    var loc = { aPos: gl.getAttribLocation(p, 'aPos'), aNor: gl.getAttribLocation(p, 'aNor'), aCol: gl.getAttribLocation(p, 'aCol') };
    ['p', 'n', 'c'].forEach(function (k, i) {
      var a = [loc.aPos, loc.aNor, loc.aCol][i];
      gl.bindBuffer(gl.ARRAY_BUFFER, m[k]); gl.enableVertexAttribArray(a); gl.vertexAttribPointer(a, 3, gl.FLOAT, false, 0, 0);
    });
    gl.drawArrays(gl.TRIANGLES, 0, m.count);
  }
  function hex(h) {
    h = (h || '').trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var v = parseInt(h, 16); if (isNaN(v)) return [.4, .5, .55];
    return [((v >> 16) & 255) / 255, ((v >> 8) & 255) / 255, (v & 255) / 255];
  }
  function mix(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }

  /* ============================================================
     1) HERO — terren malor
     ============================================================ */
  function heroScene() {
    var cv = document.querySelector('.hero__gl'); if (!cv) return;
    var gl = ctx(cv); if (!gl) return;
    var p = prog(gl); if (!p) return;
    cv.classList.add('on');
    var heroEl = cv.closest('.hero'); if (heroEl) heroEl.classList.add('gl3d');

    /* value noise */
    function hash(x, y) { var s = Math.sin(x * 127.1 + y * 311.7) * 43758.5453; return s - Math.floor(s); }
    function vn(x, y) {
      var xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi;
      var u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
      var a = hash(xi, yi), b = hash(xi + 1, yi), c = hash(xi, yi + 1), d = hash(xi + 1, yi + 1);
      return a * (1 - u) * (1 - v) + b * u * (1 - v) + c * (1 - u) * v + d * u * v;
    }
    function ridged(x, y) {
      var s = 0, amp = .5, fr = 1;
      for (var i = 0; i < 5; i++) {
        var n = 1 - Math.abs(vn(x * fr, y * fr) * 2 - 1);
        s += n * n * amp; amp *= .5; fr *= 2.03;
      }
      return s;
    }
    var W = 34, D = 30, N = 112, HS = 7.4;
    function H(gx, gz) {
      var x = (gx / N - .5) * W, z = (gz / N - .5) * D;
      var h = ridged(x * .13 + 11.3, z * .13 + 4.7) - .40;
      h = Math.max(h, 0) * HS;
      var far = Math.min(1, Math.max(0, (-z + D / 2) / D));   // më të larta në thellësi
      h *= .60 + .55 * far;
      var side = 1 - Math.min(1, Math.abs(x) / (W / 2));
      return h * (0.45 + 0.55 * Math.min(1, side * 2.2)) - .5;
    }
    var ROCK_D = hex('#152833'), ROCK_L = hex('#4A7284'), SNOW = hex('#EAF5F9'), ICE = hex('#4FC3E0');
    var m = new Mesh(), x, z;
    var hh = [];
    for (x = 0; x <= N; x++) { hh[x] = []; for (z = 0; z <= N; z++) hh[x][z] = H(x, z); }
    function P(i, j) { return [(i / N - .5) * W, hh[i][j], (j / N - .5) * D]; }
    for (x = 0; x < N; x++) for (z = 0; z < N; z++) {
      var a = P(x, z), b = P(x + 1, z), c = P(x + 1, z + 1), d = P(x, z + 1);
      var avg = (a[1] + b[1] + c[1] + d[1]) / 4;
      var slope = Math.abs(a[1] - c[1]) + Math.abs(b[1] - d[1]);
      var t = Math.min(1, Math.max(0, avg / (HS * .42)));
      var col = mix(ROCK_D, ROCK_L, Math.min(1, t * 1.5));
      var snow = Math.max(0, Math.min(1, (t - .30) * 3.4)) * Math.max(0, 1 - slope * .18);
      col = mix(col, SNOW, snow);
      if (avg < .05) col = mix(col, ICE, .30);
      col = mix(col, [1, 1, 1], (hash(x, z) - .5) * .05);
      m.quad(a, b, c, d, col);
    }
    var buf = m.upload(gl);

    var uP = gl.getUniformLocation(p, 'uP'), uV = gl.getUniformLocation(p, 'uV'), uM = gl.getUniformLocation(p, 'uM');
    var uL = gl.getUniformLocation(p, 'uLight'), uFN = gl.getUniformLocation(p, 'uFogN'),
      uFF = gl.getUniformLocation(p, 'uFogF'), uFC = gl.getUniformLocation(p, 'uFogC'),
      uFade = gl.getUniformLocation(p, 'uFade');

    var mx = 0, my = 0, tmx = 0, tmy = 0, scroll = 0, run = true, t0 = performance.now();
    window.addEventListener('pointermove', function (e) {
      tmx = (e.clientX / innerWidth - .5); tmy = (e.clientY / innerHeight - .5);
    }, { passive: true });
    window.addEventListener('scroll', function () { scroll = Math.min(1, scrollY / (innerHeight || 1)); }, { passive: true });

    var hero = cv.closest('.hero');
    if (window.IntersectionObserver) new IntersectionObserver(function (es) {
      run = es[0].isIntersecting; if (run) requestAnimationFrame(frame);
    }, { threshold: 0 }).observe(hero);

    function size() {
      var r = cv.getBoundingClientRect(), dpr = Math.min(devicePixelRatio || 1, 2);
      var w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
      if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
      return r.width / Math.max(r.height, 1);
    }
    addEventListener('resize', size);

    function frame(now) {
      if (!run) return;
      var asp = size();
      var tt = (now - t0) / 1000;
      mx += (tmx - mx) * .04; my += (tmy - my) * .04;

      gl.viewport(0, 0, cv.width, cv.height);
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      gl.enable(gl.DEPTH_TEST); gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      gl.useProgram(p);

      var eye = [mx * 1.6, 2.3 + my * .55 + scroll * 1.5, 6.4 - scroll * 1.2];
      gl.uniformMatrix4fv(uP, false, persp(0.70, asp, .1, 90));
      gl.uniformMatrix4fv(uV, false, lookAt(eye, [mx * .6, 2.5, -8], [0, 1, 0]));
      gl.uniformMatrix4fv(uM, false, mul(trans(0, 0, 0), rotY(RM ? .2 : tt * 0.012 + .2)));
      gl.uniform3f(uL, .60, .70, .38);
      gl.uniform1f(uFN, 15); gl.uniform1f(uFF, 52);
      gl.uniform3f(uFC, .16, .36, .44); gl.uniform1f(uFade, .40);
      bindDraw(gl, p, buf);
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ============================================================
     2) PDP — xhaketë 3D 360°
     ============================================================ */
  function jacketMesh(c1, c2, c3) {
    var m = new Mesh(), SEG = 26;
    // profil i trupit: [y, rx, rz]
    var body = [
      [-1.30, .62, .34], [-1.20, .66, .36], [-0.85, .64, .35], [-0.40, .60, .33],
      [0.00, .60, .33], [0.35, .64, .35], [0.62, .70, .37], [0.80, .74, .38],
      [0.92, .70, .34], [1.00, .52, .27], [1.05, .34, .20]
    ];
    function ring(y, rx, rz, ang) {
      var pts = [];
      for (var i = 0; i < SEG; i++) {
        var a = i / SEG * Math.PI * 2;
        var cx = Math.cos(a), sz = Math.sin(a);
        // superelips i butë (trup pak i sheshtë)
        var k = Math.pow(Math.abs(cx), 1.15) * (cx < 0 ? -1 : 1);
        var l = Math.pow(Math.abs(sz), 1.15) * (sz < 0 ? -1 : 1);
        pts.push([k * rx, y, l * rz]);
      }
      return pts;
    }
    var rings = body.map(function (b) { return ring(b[0], b[1], b[2]); });
    for (var i = 0; i < rings.length - 1; i++) {
      for (var j = 0; j < SEG; j++) {
        var j2 = (j + 1) % SEG;
        var col = c1;
        var a = j / SEG * Math.PI * 2;
        // panel i përparmë pak më i çelët
        if (Math.sin(a) > .55) col = mix(c1, c2, .18);
        m.quad(rings[i][j], rings[i][j2], rings[i + 1][j2], rings[i + 1][j], col);
      }
    }
    // fund + shpatull mbyllje
    var bot = rings[0], top = rings[rings.length - 1];
    for (var j = 0; j < SEG; j++) {
      var j2 = (j + 1) % SEG;
      m.tri([0, -1.30, 0], bot[j2], bot[j], mix(c1, [0, 0, 0], .35));
      m.tri([0, 1.05, 0], top[j], top[j2], mix(c1, c2, .18));
    }
    // mëngët — tub përgjatë një drejtimi
    function sleeve(side) {
      var st = [side * 0.50, 0.70, -0.02];
      var dir = norm([side * 0.42, -1, 0.04]), L = 1.95, steps = 12;
      var u = [0, 0, 1], v = norm(cross(dir, u));
      var prev = null, prevC = null;
      for (var s2 = 0; s2 <= steps; s2++) {
        var t = s2 / steps;
        var r = 0.245 - t * 0.115;
        var cen = [st[0] + dir[0] * L * t, st[1] + dir[1] * L * t, st[2] + dir[2] * L * t];
        var pts = [];
        for (var i = 0; i < SEG; i++) {
          var a = i / SEG * Math.PI * 2, ca = Math.cos(a), sa = Math.sin(a);
          pts.push([cen[0] + (u[0] * ca + v[0] * sa) * r,
                    cen[1] + (u[1] * ca + v[1] * sa) * r,
                    cen[2] + (u[2] * ca + v[2] * sa) * r * 0.92]);
        }
        if (prev) {
          for (var k = 0; k < SEG; k++) {
            var k2 = (k + 1) % SEG;
            var col = t > 0.9 ? mix(c1, c2, .32) : mix(c1, [1, 1, 1], .05 + .04 * Math.abs(Math.sin(k / SEG * Math.PI * 2)));
            m.quad(prev[k], prev[k2], pts[k2], pts[k], col);
          }
        }
        if (s2 === steps) for (var q = 0; q < SEG; q++) {
          m.tri(cen, pts[q], pts[(q + 1) % SEG], mix(c1, [0, 0, 0], .30));
        }
        prev = pts;
      }
    }
    sleeve(1); sleeve(-1);

    // kapuçi (gjysmë-sferë e shtypur, pak mbrapa)
    var HR = .42, HY = 1.02, HZ = -.12;
    for (var la = 0; la < 8; la++) for (var lo = 0; lo < SEG; lo++) {
      var t1 = la / 8 * Math.PI * .55, t2 = (la + 1) / 8 * Math.PI * .55;
      var p1 = lo / SEG * Math.PI * 2, p2 = (lo + 1) / SEG * Math.PI * 2;
      function sp(t, ph) {
        return [Math.sin(t) * Math.cos(ph) * HR * .92, HY + Math.cos(t) * HR * 1.15, HZ + Math.sin(t) * Math.sin(ph) * HR];
      }
      m.quad(sp(t1, p1), sp(t1, p2), sp(t2, p2), sp(t2, p1), mix(c1, c2, .22));
    }
    // zinxhiri (vazhdues) + slider
    (function () {
      var w = .026, y0 = -1.30, y1 = 1.02, seg = 22;
      for (var i = 0; i < seg; i++) {
        var ya = y0 + (y1 - y0) * i / seg, yb = y0 + (y1 - y0) * (i + 1) / seg;
        var za = .352 - Math.max(0, (ya - .6)) * .12, zb = .352 - Math.max(0, (yb - .6)) * .12;
        m.quad([-w, ya, za], [w, ya, za], [w, yb, zb], [-w, yb, zb], c3);
      }
      m.quad([-.055, .12, .366], [.055, .12, .366], [.055, .27, .366], [-.055, .27, .366], mix(c3, [1, 1, 1], .35));
    })();
    // xhepat
    [-1, 1].forEach(function (s3) {
      m.quad([s3 * .12, -.32, .347], [s3 * .42, -.32, .332], [s3 * .42, -.21, .332], [s3 * .12, -.21, .347], mix(c2, c1, .45));
    });
    // brezi i fundit
    (function () {
      var lo = ring(-1.31, .63, .345), hi = ring(-1.18, .665, .362);
      for (var i = 0; i < SEG; i++) {
        var j = (i + 1) % SEG;
        m.quad(lo[i], lo[j], hi[j], hi[i], mix(c1, c2, .30));
      }
    })();
    return m;
  }

  function pdpScene() {
    var cv = document.querySelector('.stage__gl'); if (!cv) return;
    var gl = ctx(cv); if (!gl) return;
    var p = prog(gl); if (!p) return;
    var stage = cv.closest('.stage'), btn = document.querySelector('[data-3d]');
    var cols = ['#12181D', '#39454C', '#4FC3E0'], buf = null, on = false;

    function build() {
      var m = jacketMesh(hex(cols[0]), hex(cols[1]), hex(cols[2]));
      buf = m.upload(gl);
    }
    build();
    window.__mg3d = { setColors: function (a, b, c) { cols = [a, b, c]; build(); } };

    var uP = gl.getUniformLocation(p, 'uP'), uV = gl.getUniformLocation(p, 'uV'), uM = gl.getUniformLocation(p, 'uM');
    var uL = gl.getUniformLocation(p, 'uLight'), uFN = gl.getUniformLocation(p, 'uFogN'),
      uFF = gl.getUniformLocation(p, 'uFogF'), uFC = gl.getUniformLocation(p, 'uFogC'),
      uFade = gl.getUniformLocation(p, 'uFade');

    var rot = -0.5, tilt = .06, drag = false, lx = 0, ly = 0, vel = 0, idle = 0;
    cv.addEventListener('pointerdown', function (e) { drag = true; lx = e.clientX; ly = e.clientY; cv.setPointerCapture(e.pointerId); cv.style.cursor = 'grabbing'; });
    cv.addEventListener('pointerup', function () { drag = false; cv.style.cursor = 'grab'; });
    cv.addEventListener('pointermove', function (e) {
      if (!drag) return;
      vel = (e.clientX - lx) * .008; rot += vel;
      tilt = Math.max(-.35, Math.min(.45, tilt + (e.clientY - ly) * .004));
      lx = e.clientX; ly = e.clientY; idle = 0;
    });

    function size() {
      var r = cv.getBoundingClientRect(), dpr = Math.min(devicePixelRatio || 1, 2);
      var w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
      if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
      return r.width / Math.max(r.height, 1);
    }
    addEventListener('resize', size);

    function frame() {
      if (!on) return;
      var asp = size();
      if (!drag) { vel *= .93; rot += vel + (RM ? 0 : .0032); }
      gl.viewport(0, 0, cv.width, cv.height);
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      gl.enable(gl.DEPTH_TEST); gl.enable(gl.BLEND); gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      gl.useProgram(p);
      gl.uniformMatrix4fv(uP, false, persp(0.62, asp, .1, 40));
      gl.uniformMatrix4fv(uV, false, lookAt([0, .1, 5.1], [0, -.06, 0], [0, 1, 0]));
      gl.uniformMatrix4fv(uM, false, mul(rotX(tilt * .5), rotY(rot)));
      gl.uniform3f(uL, .45, .72, .62);
      gl.uniform1f(uFN, 20); gl.uniform1f(uFF, 40);
      gl.uniform3f(uFC, .95, .96, .96); gl.uniform1f(uFade, 0);
      bindDraw(gl, p, buf);
      requestAnimationFrame(frame);
    }

    function toggle(state) {
      on = state === undefined ? !on : state;
      stage.classList.toggle('is3d', on);
      if (btn) btn.classList.toggle('on', on);
      if (btn) {
        // etiketat vijnë nga locale files përmes data-attributes (pa stringje të ngulitura)
        var sp = btn.querySelector('span');
        if (sp) sp.textContent = on ? (btn.dataset.labelPhoto || sp.textContent) : (btn.dataset.label360 || sp.textContent);
      }
      if (on) { cv.style.cursor = 'grab'; requestAnimationFrame(frame); }
    }
    if (btn) btn.addEventListener('click', function () { toggle(); });
    window.__mg3dToggle = toggle;
  }

  /* Progressive enhancement:
     - init vetëm kur elementi hyn në viewport (lazy)
     - respektohet data-webgl="false" (theme setting) dhe prefers-reduced-motion (RM ndal rrotullimin)
     - pa WebGL: canvas mbetet bosh dhe fallback-u statik (imazh/SVG) mbetet i dukshëm */
  function lazy(sel, fn) {
    var el = document.querySelector(sel);
    if (!el) return;
    if (el.closest('[data-webgl="false"]')) return;
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { io.disconnect(); fn(); }
    }, { rootMargin: '200px' });
    io.observe(el);
  }
  function init() { lazy('.hero__gl', heroScene); lazy('.stage__gl', pdpScene); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
